import axios from 'axios'
import {load_one} from '@/store/action-helpers'

export default {

    async create() {
        const { data } = await axios.post('/uploads', {})
        return data
    },

    loadOne: load_one('uploads/:id')

}
